module.exports = __webpack_public_path__ + "static/media/Crobat_gaussian2.12028c9e.png";